export default function ($scope, $location, products, settings, $anchorScroll, FlashService, Restangular) {

    $scope.promo = {
        product: findProduct(find('promo_product', null)),
        duration: find('promo_duration', null),
        licence: find('promo_licence_days', null),
        enabled: find('promo_enabled', false),
        text: find('promo_text', {}),
    };

    $scope.days = [
        {value: '', label: 'None'},
        {value: '1', label: '1 día'},
        {value: '5', label: '5 dias'},
        {value: '10', label: '10 dias'},
        {value: '20', label: '20 dias'},
        {value: '30', label: '30 dias'},
        {value: '45', label: '45 dias'},
        {value: '60', label: '60 dias'},
        {value: '75', label: '75 dias'},
        {value: '90', label: '90 dias'},
    ];

    $scope.querySearch = function (query) {
        return query ? products.filter(createFilterFor(query)) : products;

    }

    function createFilterFor(query) {
        let lowercaseQuery = angular.lowercase(query);

        return function filterFn(product) {
            return (angular.lowercase(product.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    function find(query, def) {
        const setting = settings.find(function (config) {
            return config.name === query;
        });

        if(!setting){
            return def;
        }

        if(typeof setting.value == 'object' && setting.value.length == 0 ){
            return def;
        }

        if (setting.value) {
            return setting.value;
        }

        return def;
    }

    function findProduct(query) {
        return products.find(function(product) {
            return product.id === query;
        });


        return null;
    }

    $scope.save = function () {
        $scope.dataLoading = true;

        let data = {
            promo_enabled: $scope.promo.enabled,
            promo_product: $scope.promo.product ? $scope.promo.product.id : null,
            promo_duration: $scope.promo.duration,
            promo_licence_days: $scope.promo.licence,
            promo_text: $scope.promo.text
        };

        data.fields = Object.keys(data);

        Restangular
            .all('settings')
            .customPOST(data, false)
            .then(data => {

                FlashService.Success("Se ha guardado correctamente");

                $scope.dataLoading = false;

                //$location.path('/login');

            }, error => {
                $scope.dataLoading = false;

                $anchorScroll("navbar");
                FlashService.Error("Se han encontrado errores contacta tu administador de sistema");

                error.data.fields.forEach(function (field, index) {
                    if (field.property_path == 'email' || field.property_path == 'username') {
                        $scope.form[field.property_path].$setValidity('exists', false);
                    }

                    if (field.property_path == 'plainPassword') {
                        $scope.form[field.property_path].$setValidity('low', false);
                    }
                });

                form.$invalid = false;

            });
    }


};


/** WEBPACK FOOTER **
 ** ./js/theme/options/controller.js
 **/